export interface EventEffectLike {
  effects?: Record<string, unknown>;
  effectDeltas?: {
    stats?: Record<string, unknown>;
    environmental?: Record<string, unknown>;
  };
  details?: {
    effects?: Record<string, unknown>;
    environmental?: Record<string, unknown>;
  } | Record<string, unknown>;
}

const LABELS: Record<string, string> = {
  primitiveLife: 'Life',
  animalLife: 'Animals',
  researchSpeed: 'Research',
  scanRange: 'Mapped',
  pollution: 'Pollution',
};

function labelFor(key: string) {
  return LABELS[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (c) => c.toUpperCase());
}

export function getEventEffectEntries(event: EventEffectLike) {
  const details = event.details as EventEffectLike['details'] | undefined;
  const stats = event.effectDeltas?.stats || (details?.effects as Record<string, unknown> | undefined) || {};
  const environmental = event.effectDeltas?.environmental || (details?.environmental as Record<string, unknown> | undefined) || {};
  const combined = {
    ...event.effects,
    ...stats,
    ...(typeof environmental?.pollution === 'number' ? { pollution: environmental.pollution } : {}),
  };

  return Object.entries(combined)
    .filter(([, value]) => typeof value === 'number' && Math.abs(value) > 0)
    .map(([key, value]) => ({
      key,
      label: labelFor(key),
      value: value as number,
      text: `${value as number > 0 ? '+' : ''}${Math.round((value as number) * 10) / 10} ${labelFor(key)}`,
    }));
}

export function formatEventEffects(event: EventEffectLike) {
  return getEventEffectEntries(event).map((entry) => entry.text).join(', ');
}
